export default "__VITE_ASSET__VKAXQxOz__"